import React from 'react';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => (
  {
    tableParent: {
      width: '100%',
      overflowX: 'auto',
      marginBottom: '2vh',
    },
    table: {
      minWidth: 500,
    },
  }
));

const Account = ({ userInfo }) => {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h6" gutterBottom>Mes informations</Typography>
      <div className={classes.tableParent}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Nom</TableCell>
              <TableCell>Prénom</TableCell>
              <TableCell>Téléphone</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{userInfo.email}</TableCell>
              <TableCell>{userInfo.lastname}</TableCell>
              <TableCell>{userInfo.firstname}</TableCell>
              <TableCell>{userInfo.mobile}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

Account.propTypes = {
  userInfo: PropTypes.object,
};

export default Account;



// WEBPACK FOOTER //
// ./src/components/Account/Account.jsx